<div class="steps">
  <div class="d-flex-sm {{ lineStyles[0] }}">
    <span class="round">1</span>Validação do Celular
  </div>
  <div class="line {{ lineStyles[1] }}"></div>
  <div class="d-flex-sm {{ lineStyles[1] }}">
    <span class="round">2</span>Foto do Cliente
  </div>
</div>

<form [formGroup]="autenticacaoForm">
  <ng-container [ngSwitch]="step">
    <app-validacao-celular
      *ngSwitchCase="STEPS.VALIDACAO_CELULAR"
      (onCancel)="cancelarValidacaoCelular()"
      (onSuccessValidate)="celularValidado()"
    ></app-validacao-celular>

    <app-captura-foto
      *ngSwitchCase="STEPS.CAPTURA_BIOMETRIA"
      formControlName="biometria"
      [isLojistaPiloto]="isLojistaPiloto"
      [propostaId]="proposta.id"
      [celularFoiValidado]="celularFoiValidado"
      (finalizarBiometria)="finalizarBiometria()"
      (excluirFicha)="excluirFicha()"
    ></app-captura-foto>

    <div *ngSwitchCase="STEPS.VALIDACAO_CELULAR_NAO_REALIZADA">
      <ng-container
        [ngTemplateOutlet]="validacaoNaoRealizadaTemplate"
      ></ng-container>
    </div>

    <div *ngSwitchCase="STEPS.AUTENTICACAO_REALIZADA">
      <ng-container
        [ngTemplateOutlet]="autenticacaoRealizadaTemplate"
      ></ng-container>
    </div>
  </ng-container>
</form>

<ng-template #validacaoNaoRealizadaTemplate>
  <div class="modal-body valicadacao-nao-realizada text-left">
    <span class="icon warning-2"></span>
    <p>
      Parece que o cliente não realizou a validação do celular. Lembre-se que
      desta forma não será possível realizar a assinatura digital do contrato.
    </p>
  </div>
</ng-template>

<ng-template #autenticacaoRealizadaTemplate>
  <div class="modal-body autenticacao-realizada centered">
    <span class="icon thumbs-up"></span>Tudo certo com a etapa de Autenticação
    do Cliente.
  </div>
</ng-template>
